<template>
  <div class="EventContributorsList__wrapper">
    <h3
      v-if="stageList && stageList.length"
      class="EventContributorsList__heading"
    >
      {{ translations.onStage }}
    </h3>
    <div class="EventContributorsList__section">
      <ul class="EventContributorsList__list">
        <template v-for="contributor in stageList">
          <li v-if="stageList">
            <Contributor
              v-if="contributor.type === 'person'"
              :contributor="contributor"
            />
            <Comment v-else :comment="contributor.text" />
          </li>
        </template>
      </ul>
    </div>

    <h3
      v-if="productionList && productionList.length"
      class="EventContributorsList__heading"
    >
      {{ translations.production }}
    </h3>
    <div class="EventContributorsList__section">
      <ul class="EventContributorsList__list">
        <template v-for="contributor in productionList">
          <li v-if="productionList">
            <Contributor
              v-if="contributor.type === 'person'"
              :contributor="contributor"
            />
            <Comment v-else :comment="contributor.text" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Contributor from "./Contributor";
import Comment from "./Comment.vue";

export default {
  name: "EventContributorsList",
  components: { Contributor, Comment },
  data() {
    return {
      translations: {
        onStage: Drupal.t("On stage"),
        production: Drupal.t("Production"),
      },
    };
  },
  computed: {
    ...mapGetters({
      eventData: "getEventData",
    }),
    event() {
      return this.eventData[drupalSettings.nid];
    },
    stageList() {
      if (this.event.contributors.on_stage) {
        return this.event.contributors.on_stage.filter((contributor) => {
          return contributor.persons && contributor.text && contributor.type;
        });
      } else {
        return false;
      }
    },
    productionList() {
      if (this.event.contributors.production) {
        return this.event.contributors.production.filter((contributor) => {
          return contributor.persons && contributor.text && contributor.type;
        });
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.EventContributorsList__wrapper {
  @include container--text;
  .a11y-paragraphs-tabs__wrapper & {
    margin: 0;
    margin-bottom: 3rem;
    padding: 0;
  }
}

.EventContributorsList__heading {
  margin-top: 0;
  font-size: 24px;
  line-height: 46px;
  color: black;
}

.EventContributorsList__section {
  .EventContributorsList__list {
    list-style: none;
    padding-left: 30px;
    margin: 0;
    @include breakpoint($phone-small) {
      margin-left: 60px;
    }
  }
}
</style>
